import React, { Component } from 'react';
import { store } from './stores/mainStore';
import { observer } from 'mobx-react';

import { Main } from './components/Main';
import { CommandQueue } from './webview/CommandQueue'

@observer
class App extends Component {
	constructor(){
		super();
		window.store = store;
		window.CommandQueue = new CommandQueue(window.CommandQueue);
		window.WrapperApp.postMessage("get-info");
		// setTimeout(() => {
		// 	if(!store.localStorageSynced){
		// 		//if this screen is up for more than 2 seconds restart.
		// 		window.location.reload();
		// 	}
		// }, 2000);
	}
	render() {
		if(!store.localStorageSynced){
			return <div style={{color: 'red'}}></div>
		}

		return (
			<Main/>
		);
	}
}

export { App };
